import React from "react";
import PageHeader from "@/components/PageHeader";
import Destinations from "@/components/Destinations";
import Packages from "@/components/Packages";
import CtaBanner from "@/components/CtaBanner";
import { useLayout } from "@/components/Layout";

export default function DestinationsPage() {
  const { openPlan } = useLayout();
  return (
    <div data-testid="destinations-page">
      <PageHeader
        overline="International Holidays"
        title={"Ten signature destinations,\nendless ways to wander."}
        subtitle="Every destination has been travelled personally by our consultants. Choose a country to see our curated 5-star hotels, private experiences and hand-crafted itineraries."
        image="https://images.unsplash.com/photo-1499856871958-5b9627545d1a?q=80&w=2000&auto=format&fit=crop"
      />
      <Destinations onExplore={() => {}} />
      <Packages onBook={(p) => openPlan({ destination: p.name })} />
      <CtaBanner onPlanTrip={() => openPlan()} />
    </div>
  );
}
